<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><i class="el-icon-lx-calendar" /> 生产管理</el-breadcrumb-item>
        <el-breadcrumb-item>生产信息</el-breadcrumb-item>
        <el-breadcrumb-item>内外码导入错误</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <el-form ref="searchForm" :model="searchForm" label-width="76px" class="search-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="工单号" prop="orderNo">
              <el-input v-model.trim="searchForm.orderNo" clearable placeholder="请输入完整工单号" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="批次码" prop="innerCode">
              <el-input v-model.trim="searchForm.innerCode" clearable placeholder="请输入完整批次码" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="错误类型" prop="errorType">
              <el-select v-model="searchForm.errorType" clearable placeholder="全部类型" style="width:100%">
                <el-option v-for="item in errorTypes" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6" class="search-actions">
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table v-loading="loading" :data="rows" border style="width:100%">
        <el-table-column prop="qrcode_orderno" label="工单号" min-width="170" show-overflow-tooltip />
        <el-table-column prop="import_batch_no" label="导入批次号" min-width="210" show-overflow-tooltip />
        <el-table-column prop="error_type" label="错误类型" min-width="130">
          <template slot-scope="scope">
            <el-tag :type="errorTag(scope.row.error_type)" size="mini">{{ errorLabel(scope.row.error_type) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="数量" width="90" align="right" />
        <el-table-column prop="latest_create_time" label="最新时间" min-width="170">
          <template slot-scope="scope">{{ formatDate(scope.row.latest_create_time) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="72" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetails(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        background
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[20, 50, 100, 200]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="changePage"
        @size-change="changePageSize"
      />
    </div>

    <el-dialog :title="detailTitle" :visible.sync="detailVisible" width="82%" @closed="clearDetails">
      <el-table v-loading="detailLoading" :data="detailRows" border style="width:100%">
        <el-table-column prop="inner_code" label="批次码（内码）" min-width="190" show-overflow-tooltip />
        <el-table-column prop="outer_code" label="实体码（外码）" min-width="190" show-overflow-tooltip />
        <el-table-column prop="error_reason" label="错误详情" min-width="300" show-overflow-tooltip />
        <el-table-column prop="create_time" label="记录时间" min-width="170">
          <template slot-scope="scope">{{ formatDate(scope.row.create_time) }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        :current-page="detailPageIndex"
        :page-size="detailPageSize"
        :page-sizes="[20, 50, 100, 200]"
        :total="detailTotal"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="changeDetailPage"
        @size-change="changeDetailPageSize"
      />
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProductionImportErrors,
  getProductionImportErrorDetails,
  getProductionImportErrorTypes
} from '@/api/productionImport'

export default {
  name: 'ProductionImportError',
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      pageIndex: 1,
      pageSize: 20,
      errorTypes: [],
      selectedGroup: null,
      detailVisible: false,
      detailLoading: false,
      detailRows: [],
      detailTotal: 0,
      detailPageIndex: 1,
      detailPageSize: 20,
      searchForm: {
        orderNo: '',
        innerCode: '',
        errorType: ''
      }
    }
  },
  computed: {
    detailTitle() {
      if (!this.selectedGroup) return '错误详情'
      return `${this.selectedGroup.qrcode_orderno} / ${this.errorLabel(this.selectedGroup.error_type)}`
    }
  },
  created() {
    getProductionImportErrorTypes().then(response => {
      this.errorTypes = response.data || []
    })
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      getProductionImportErrors({
        orderNo: this.searchForm.orderNo,
        innerCode: this.searchForm.innerCode,
        errorType: this.searchForm.errorType,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(response => {
        const result = response.data || {}
        this.rows = result.data || []
        this.total = result.total_count || 0
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.pageIndex = 1
      this.load()
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.pageIndex = 1
      this.load()
    },
    changePage(page) {
      this.pageIndex = page
      this.load()
    },
    changePageSize(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.load()
    },
    showDetails(row) {
      this.selectedGroup = row
      this.detailPageIndex = 1
      this.detailVisible = true
      this.loadDetails()
    },
    loadDetails() {
      if (!this.selectedGroup) return
      this.detailLoading = true
      getProductionImportErrorDetails({
        orderNo: this.selectedGroup.qrcode_orderno,
        importBatchNo: this.selectedGroup.import_batch_no,
        errorType: this.selectedGroup.error_type,
        innerCode: this.searchForm.innerCode,
        pageIndex: this.detailPageIndex,
        pageSize: this.detailPageSize
      }).then(response => {
        const result = response.data || {}
        this.detailRows = result.data || []
        this.detailTotal = result.total_count || 0
      }).finally(() => {
        this.detailLoading = false
      })
    },
    changeDetailPage(page) {
      this.detailPageIndex = page
      this.loadDetails()
    },
    changeDetailPageSize(size) {
      this.detailPageSize = size
      this.detailPageIndex = 1
      this.loadDetails()
    },
    clearDetails() {
      this.selectedGroup = null
      this.detailRows = []
      this.detailTotal = 0
    },
    errorLabel(value) {
      const item = this.errorTypes.find(option => option.value === value)
      return item ? item.label : value
    },
    errorTag(value) {
      if (value === 'DUPLICATE_IN_FILE' || value === 'INNER_CODE_DUPLICATE') return 'warning'
      return 'danger'
    },
    formatDate(value) {
      return value ? String(value).replace('T', ' ').replace(/\.\d+$/, '') : '-'
    }
  }
}
</script>

<style scoped>
.search-form {
  margin-bottom: 8px;
}
.search-actions {
  padding-top: 2px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
